var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { member, useAuthContext } from "../../store/login.store";
import { useEffect } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { isMobile } from "../../app/Routes";
export default function ClarificationInfo() {
    var currentPage = window.location.href;
    var isAuthenticated = useAuthContext().isAuthenticated;
    var params = useParams();
    var _a = useSearchParams(), searchParams = _a[0], setSearchParams = _a[1];
    // useEffect(() => {
    //     // console.log("currentPage");
    //     // console.log(currentPage);
    // }, [currentPage]);
    useEffect(function () {
        // console.log("params");
        // console.log(currentPage);
    }, [params]);
    var calculateWidth = function () {
        if (isMobile) {
            return 'unset';
        }
        if (currentPage.includes("/iddaa/") && currentPage.includes("tumu")) {
            return 'calc(100% - 316px)';
        }
        else if (currentPage.includes("/iddaa/") && currentPage.includes("canli")) {
            return 'calc(100% - 316px)';
        }
        else if (currentPage.includes("/sosyoley/")) {
            return 'calc(100% - 316px)';
        }
        else if (currentPage.includes("/duyurular")) {
            return 'calc(100% - 316px)';
        }
        return '100%';
    };
    //
    if (isAuthenticated && member.id && member.clarificationrequest) {
        return (_jsx("div", __assign({ className: "alert alert-danger text-center", style: {
                width: calculateWidth(),
                marginLeft: isMobile ? '-15px' : "0",
                marginRight: isMobile ? '-15px' : "0",
                marginBottom: isMobile ? '0' : "0.5rem",
                borderRadius: isMobile ? '0' : '6px'
            } }, { children: member.clarificationrequest }), void 0));
    }
    else {
        return _jsx(_Fragment, {}, void 0);
    }
}
